import { AlertTriangle } from 'lucide-react';

// ¿El plan de la ficha coincide con las clases en que está inscrita? (25-sep-2026, pedido de Carlos).
// El backend lo calcula (lib/letsmovePlanClases.js) y lo manda como `plan_check` en la ficha. Si
// coincide o el plan no se comprueba (All Dance, sin membresía), no se enseña nada.
export interface PlanCheck {
  plan: string; esperadas: number; inscritas: number; clases: string[]; coincide: boolean;
  // 25-sep-2026: combinación con precio propio (Femme + otra disciplina → «Femme + 1 disciplina»)
  sugerido?: { plan: string; precio: number } | null; motivo?: 'femme' | 'fe1_sin_femme' | null;
}

const clasesTxt = (n: number) => `${n} clase${n === 1 ? '' : 's'}`;

export default function PlanClasesAviso({ check, className = '' }: { check?: PlanCheck | null; className?: string }) {
  if (!check || check.coincide) return null;
  return (
    <div role="status" data-testid="plan-clases-aviso"
      className={`flex items-start gap-2 rounded-lg border border-amber-500/40 bg-amber-500/10 px-3 py-2 text-xs text-content-2 ${className}`}>
      <AlertTriangle size={14} className="mt-0.5 shrink-0 text-amber-600 dark:text-amber-400" />
      <span>
        {check.motivo === 'femme' && check.sugerido
          ? <>Va a <b className="text-content">{check.clases.join(' + ')}</b>: con Femme el plan es{' '}
              <b className="text-content">{check.sugerido.plan}</b> (${check.sugerido.precio.toLocaleString('es-MX')}), no «{check.plan}». Cámbialo en su ficha antes de cobrar.</>
          : check.motivo === 'fe1_sin_femme'
          ? <>Su plan es <b className="text-content">{check.plan}</b>, pero no está inscrita en Femme ({check.clases.join(', ')}). Revisa el plan.</>
          : check.inscritas === 0
          ? <>Su plan es <b className="text-content">{check.plan}</b>, pero no está inscrita en ninguna clase vigente. ¿Sigue viniendo?</>
          : <>Su plan <b className="text-content">{check.plan}</b> incluye {clasesTxt(check.esperadas)} y está inscrita en{' '}
              <b className="text-content">{clasesTxt(check.inscritas)}</b> ({check.clases.join(', ')}). Revisa el plan o sus inscripciones.</>}
      </span>
    </div>
  );
}
